import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';

interface IProps{}
interface IState{
  collapsed: boolean
}

export class NavMenu extends Component<IProps, IState> {
  static displayName = NavMenu.name;

  constructor(props: any) {
    super(props);

    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    return (
      <header>
        <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white border-bottom box-shadow mb-3 text-white" light>
          <Container>
            <NavbarBrand className="text-white" tag={Link} to="/"><img src="../images/logo.png" style={{ height: "50px" }} /></NavbarBrand>
            <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
              <NavLink tag={Link} className="text-white" to='/memberList'>Members</NavLink>
              <NavLink tag={Link} className="text-white" to='/bulkUpload'>Bulk Upload Members</NavLink>
              <NavLink tag={Link} className="text-white" to='/events'>Events</NavLink>
            <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
              <ul className="navbar-nav flex-grow">
                <NavItem>
                  <a className="text-white nav-link" href="/new-member">New Member</a>
                </NavItem>
                <LoginMenu>
                </LoginMenu>
              </ul>
            </Collapse>
          </Container>
        </Navbar>
      </header>
    );
  }
}
